import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQueryClient, useMutation } from 'react-query';

function useSupportTopic() {
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;
  const queryClient = useQueryClient();

  function createTopic({ categoryId, ...rest }) {
    return privateFetch.post(`/v1/admin/support/category/${categoryId}/topic`, rest);
  }

  function updateTopic({ categoryId, topicId, ...rest }) {
    return privateFetch.put(`/v1/admin/support/category/${categoryId}/topic/${topicId}`, rest);
  }

  function manageTopic(data) {
    if (data.topicId) return updateTopic(data);
    return createTopic(data);
  }

  return useMutation(manageTopic, {
    onSuccess() {},
    onError() {},
    onSettled() {
      queryClient.invalidateQueries('support-topic');
    },
  });
}

export default useSupportTopic;
